import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation} from "react-router-dom";
import { history } from '_helpers/history'

import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import AuthBg from "../../components/background/AuthBg";
import {xcService} from "../../_services/xcService";
import variables from "../../_constants/variables";


import localOrSessionStore from "_helpers/localOrSessionStore";


function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ActivateCenter(props) {
  let query = useQuery();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const tokenActivation = query.get("token");

  const authA = query.get("auth");
  const storage = localOrSessionStore({ key: variables.REMEMBER });
  const [errorActivation, setErrorActivation] = useState(false);
  useEffect(() => {
    setErrorActivation(false)
   xcService.post("/v1/family/auth/login",{email: tokenActivation, token:authA}).then(data => {
     if (data.status === 200){
       storage.setItem(variables.AUTH, "true");
       storage.setItem(variables.COMPLET, "0");
       storage.setItem(variables.TOKEN, data.data.data.token);
       storage.setItem(variables.TOKENREFRESH, data.data.data.refreshToken);
       storage.setItem(variables.USER, JSON.stringify(data.data.data.user));
       storage.setItem(variables.USER_TYPE, "FAMILY");
       window.location.replace("/admin/informes?year="+data.data.data.user.year);

     }else{
       setErrorActivation(true)
     }
   })

  }, []);


  return (
    <>
      <div className="containerRowRegister">
        <NavbarNoLogin className="menuNavRegister"/>


        <div className="colRegister leftRegister">
          <h1>{t("welcome")}</h1>

          <AuthBg/>

        </div>
        <div className="colRegister rightRegister">
          <div className="headerMobile">
            <h1>{t("welcome")}</h1>

          </div>

          <div className="containerRegister">

            {errorActivation &&
                <div className="centerRegister">
                  <div className={"steps is-scrollable is-scrollable--center-end"}>
                    <div className={"contratoEnviado"}>
                      <h3>{t("linknov")}</h3>
                      <p dangerouslySetInnerHTML={{__html: t('linknov2')}}/>
                      <Button
                          onClick={() => history.push("/default/index")}
                          type={"primary"}
                          className="primaryButton buttonSizeXXL"
                      >
                        {t("menu.inicio")}
                      </Button>
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
    </>
  );
}
export default withTranslation()(ActivateCenter);
